import API from '@/api/index';
import * as Auth from '@/utils/auth';

const user = {
  state: {
    token: Auth.getAccessToken(),
    refreshToken: Auth.getRefreshToken(),
    loggedUser: Auth.getLoggedUser(),
    forgotPasswordEmail: '',
    forgotPasswordPhone: '',
    forgotPasswordOTP: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      let access_token = token ? token.access_token : '';
      Auth.setAccessToken(access_token);
      state.token = access_token;

      let refresh_token = token ? token.refresh_token : '';
      Auth.setRefreshToken(refresh_token);
      state.refreshToken = refresh_token;
    },
    SET_LOGGED_USER: (state, loggedUser) => {
      Auth.setLoggedUser(loggedUser);
      state.loggedUser = loggedUser;
    },
    SET_FORGOT_PASSWORD_EMAIL: (state, email) => {
      state.forgotPasswordEmail = email;
    },
    SET_FORGOT_PASSWORD_PHONE: (state, phone) => {
      state.forgotPasswordPhone = phone;
    },
    SET_FORGOT_PASSWORD_OTP: (state, otp) => {
      state.forgotPasswordOTP = otp;
    },
  },

  actions: {
    loginByUsername ({ commit, dispatch }, loginModel) {
      return new Promise((resolve, reject) => {
        API.login
          .loginByUsername(loginModel)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.json;
              commit('SET_TOKEN', token);

              dispatch('getUserInfo').then(res => {
                if (res) resolve(res);
                else reject(res);
              });
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        API.login
          .getUserInfo(state.token)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let user = result.data;
              commit('SET_LOGGED_USER', user);
              resolve(result.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    register ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .register(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateProfile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .updateProfile(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changePassword ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .changePassword(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    checkPhone ({ state }, phoneNumber) {
      return new Promise((resolve, reject) => {
        API.user
          .checkPhone(phoneNumber)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    checkEmail ({ state }, email) {
      return new Promise((resolve, reject) => {
        API.user
          .checkEmail(email)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getAccesstokenZalo ({ state }, email) {
      return new Promise((resolve, reject) => {
        API.user
          .getAccesstokenZalo(email)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data.access_token);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    requestOtp ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .requestOtp(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    checkOtp ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .checkOtp(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    forgotPassword ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .forgotPassword(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    logOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_LOGGED_USER', '');
        commit('SET_VEHICLES', [], { root: true });
        commit('SET_MAINTENANCES', [], { root: true });
        commit('SET_SELECTED_VEHICLES', null, { root: true });
        commit('RESET_UTC_TICKS', { root: true });

        Auth.removeToken();
        resolve();
      });
    },

    registerFirebaseToken ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .registerFirebaseToken(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    removeFirebaseToken ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .removeFirebaseToken(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    loginFacebook ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .loginFacebook(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.json;
              commit('SET_TOKEN', token);

              dispatch('getUserInfo').then(res => {
                if (res) resolve(res);
                else reject(res);
              });
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    loginGoogle ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .loginGoogle(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.json;
              commit('SET_TOKEN', token);

              dispatch('getUserInfo').then(res => {
                if (res) resolve(res);
                else reject(res);
              });
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    loginZalo ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .loginZalo(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.json;
              commit('SET_TOKEN', token);

              dispatch('getUserInfo').then(res => {
                if (res) resolve(res);
                else reject(res);
              });
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    linkToFacebook ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .linkToFacebook(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    linkToGoogle ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .linkToGoogle(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    linkToZalo ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .linkToZalo(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    cancelThirdParty ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .cancelThirdParty(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js